// extracted by mini-css-extract-plugin
module.exports = {"root":"DesignerInfoNav-module__root___2K2Or","button":"DesignerInfoNav-module__button___3BxNZ","active":"DesignerInfoNav-module__active___2jSGE"};